<script>
    export let questionWrapper; //all of the question data JSON
    export let questionNumber; //what number question you are on
    export let questionCount; //total number of questions
    export let quizTitle; //bring in the quiz title for data tracking
    import correctCount from "./correct-count-store.js"; //tracking how many questions were selected correctly
    import nextq from "./next-question-number-store.js"; //tracking which number question comes next to show/hide next/previous
    let selected = ""; //bolds selected element
    let correct = ""; //returns correct or incorrect
    //checks if an answer was already selected, and doesn't change the value of correct if so
    function correctCheck(data, correct) {
        if (correct === "") {
            if (data == "correct") {
                correctCount.update((n) => n + 1);
                //correctCount++;
                console.log("is correct");
                correct = "correct";
            } else {
                console.log("is not correct");
                correct = "incorrect";
            }
        }
        return correct;
    }
    //check if an answer was already selected, and don't change the value of selected if so
    function selectedCheck(selected, answerWrapper, correct) {
        if (correct === "") {
            return answerWrapper;
        } else {
            return selected;
        }
    }
    questionWrapper.answerList.sort(() => Math.random() - 0.5); //randomize answer options
</script>

<h4>Question {questionNumber} of {questionCount}:</h4>
<div
    class="question {questionWrapper.question.questionImage.url === ''
        ? 'no-image'
        : 'has-image'}"
    style="background-image: url({questionWrapper.question.questionImage.url})"
>
    <span class="attribution"
        >{questionWrapper.question.questionImage.attribution}</span
    >
</div>
<h2>{questionWrapper.question.questionText}</h2>
<div
    class="answers {questionWrapper.answerList[0].answer.answerImage.url === ''
        ? 'text'
        : 'image'}"
>
    {#each questionWrapper.answerList as answerWrapper, index}
        <div
            class="answer {answerWrapper.answer.answerImage.url === ''
                ? 'text'
                : 'image'}"
        >
            <input
                type="radio"
                name="question_{questionNumber}"
                value={answerWrapper.answer.answerText}
                id="question_{questionNumber}_answer_{index + 1}"
                disabled={correct !== ""}
            />
            <label
                data-track-event="{quizTitle}|{questionWrapper.question
                    .questionText} - Answer Click|{answerWrapper.answer
                    .answerText}"
                for="question_{questionNumber}_answer_{index + 1}"
                class="{correct === ''
                    ? ''
                    : answerWrapper.answer.isCorrect} {selected ===
                answerWrapper
                    ? 'selected'
                    : ''}"
                on:click|once={() => (
                    (selected = selectedCheck(
                        selected,
                        answerWrapper,
                        correct
                    )),
                    (correct = correctCheck(
                        answerWrapper.answer.isCorrect,
                        correct
                    ))
                )}
            >
                {#if answerWrapper.answer.answerImage.url === ""}
                    {answerWrapper.answer.answerText}
                {:else}
                    <div
                        class="image"
                        style="background-image: url({answerWrapper.answer
                            .answerImage.url})"
                    >
                        <span class="attribution"
                            >{answerWrapper.answer.answerImage
                                .attribution}</span
                        >
                    </div>
                    {#if answerWrapper.answer.answerText != ""}
                        <p>{answerWrapper.answer.answerText}</p>
                    {/if}
                {/if}
            </label>
        </div>
    {/each}
</div>

<div class="explanation {correct === '' ? 'hide' : 'show'}">
    {#if correct === "correct"}
        <h3>That's right!</h3>
    {:else if correct === "incorrect"}
        <h3>Almost!</h3>
    {/if}
    <p>{questionWrapper.explanationText}</p>
    {#if $nextq === questionCount}
        <p
            data-track-event="{quizTitle}|{questionWrapper.question
                .questionText} - Next Button Click|See My Score"
            class="next"
            on:click={() => nextq.update((n) => n + 1)}
        >
            See My Score
        </p>
    {:else}
        <p
            data-track-event="{quizTitle}|{questionWrapper.question
                .questionText} - Next Button Click|Next Question"
            class="next"
            on:click={() => nextq.update((n) => n + 1)}
        >
            Next Question
        </p>
    {/if}
</div>

<style>
    div.question.has-image {
        height: 200px;
        width: 450px;
        background-size: cover;
        background-position: 50%;
        position: relative;
    }
    div.question.no-image {
        display: none;
    }
    div.answers.image {
        /*padding: 0 30px;*/
        text-align: center;
    }
    div.answer.text {
        display: block;
    }
    div.answer.image {
        display: inline-block;
        margin: 0 7px;
        max-width: 185px;
    }
    div.answer input {
        display: none;
    }
    div.answer label {
        display: block;
        border: 2px solid #000;
        padding: 10px;
        margin: 5px auto;
        background-color: #fff;
        text-align: center;
        transition: background-color 0.5s linear;
    }
    div.answer label div.image {
        height: 160px;
        width: 160px;
        background-size: cover;
        background-position: 50%;
        position: relative;
    }
    div.answer label div.image .attribution,
    div.question.has-image .attribution {
        position: absolute;
        bottom: 3px;
        right: 4px;
        color: rgba(255, 255, 255, 0.9);
        text-shadow: 2px 2px 4px rgb(0 0 0 / 60%);
        font-size: 0.5em;
    }
    div.answer label:hover {
        background-color: #ccc;
    }
    div.answer label.correct {
        color: green;
        background-color: #d4f0d5;
        border: 2px solid green;
        font-weight: bold;
    }
    div.answer label.incorrect {
        color: red;
        background-color: #f8e0e0;
        border: 2px solid #9e1919;
        opacity: 0.7;
    }
    div.answer label.selected {
        border-width: 3px;
    }
    div.explanation {
        padding: 15px 20px;
        border: 2px solid #000;
        margin: 15px auto;
    }
    p.next {
        display: block;
        background-color: #ffaf4f;
        padding: 15px 10px;
        margin: 10px 10px 10px auto;
        color: #222;
        font-weight: bold;
        text-align: center;
        max-width: 150px;
        font-size: 1.1rem;
        transition: background-color 0.25s linear;
    }
    p.next:hover {
        background-color: #f6941e;
    }
    .show {
        display: block;
    }
    .hide {
        display: none;
    }
</style>
